import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import Modal from 'react-modal';

import './dashboard.scss';
import { DashboardHeader } from '../../atoms';
import {  DashContainer, DashContentFooter } from '../../molecules';
import { DashboardContext, UserContext } from '../../../context';
function Dashboard() {
  Modal.setAppElement('#root');
  //const history = useHistory();

  const [dashData, setDashData] = useState({});
  //const { user, setUser } = useContext(UserContext);

  useEffect(() => {
    document.body.style.backgroundColor = '#ffffff';
  });

  // useEffect(() => {
  //   ////console.log('dash data updated: ', JSON.stringify(dashData));
  // }, [dashData]);

  return (
    <DashboardContext.Provider value={{ dashData, setDashData }}>
      <div className='row no-gutters'>
        <div className='no-gutters dash-left-wrapper'>
          <DashboardHeader />
          <DashContainer />
          <DashContentFooter />
        </div>

      </div>

    </DashboardContext.Provider>
  );
}

export default Dashboard;
